<template>
  <div class="main">
    <van-image
      fit="cover"
      src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product/9.jpg"
      class="banner"
    />
    <!-- <div class="oldWorld" @click="go">旧版入口</div> -->
    <!-- 产品介绍 -->
    <Introduce
      :title="'未来课堂'"
      :desc="'VR未来课堂将虚拟现实技术与实际教育教学知识点紧密结合，覆盖中小学语文、英语、科学、物理、化学、生物、地理、历史、安全、国学、心理等内容，以多种形式灵活应用于课堂教学、科技馆等不同场景，以优质VR教学资源为核心，打造与实际教育教学高度结合的高仿真、沉浸式、可交互的一体化课堂。'"
      :img="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product/6.png'"
    ></Introduce>
    <!-- 具体内容 -->
    <div class="details">
      <div class="title">K12内容</div>
      <div class="content">
        <img
          src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product/7.png"
          alt=""
        />
        <img
          src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product/8.png"
          alt=""
        />
      </div>
      <div class="desc">
        未来课堂现拥有10000+个XR教学课程资源，内容覆盖国家课程小学、初中、高中多学段的语文、科学、物理、化学、历史、地理等多个学科的众多主题，也有安全教育课程、国学教育课程、爱国主义教育课程等
      </div>
    </div>
    <!-- 产品特点 -->
    <!-- <div class="constitute">
      <div>
        <div class="title">方案构成</div>
        <div class="content">
          <div class="list" v-for="item of constitute" :key="item">
            <img :src="item.img" alt="" />
            <div class="headline">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div> -->
    <Constitute :title="'方案构成'" :constitute='constitute'></Constitute>
    <!-- 主要功能模块 -->
    <!-- <div class="plan">
      <div class="title">主要功能模块</div>
      <div class="content">
        <div class="list" v-for="item of list" :key="item">
          <img src="" alt="" />
          <div class="desc">智能化学习教育</div>
        </div>
      </div>
    </div> -->
    <!-- 线下场景 -->
    <!-- <div class="offline">
      <div class="title">线下场景</div>
      <div class="content">
        <img src="" alt="">
        <img src="" alt="">
        <img src="" alt="">
      </div>
    </div> -->
    <!-- 客户案例 -->
    <Eg :list="listK12"></Eg>
  </div>
</template>
<script>
import Eg from '@/component/example';
import Introduce from '@/component/introduce';
import Constitute from '@/component/constitute';
export default {
  components: {
    Eg,
    Introduce,
    Constitute
  },
  data() {
    return {
      list: [1, 2, 3, 4],
      constitute: [
        {
          title: '全沉浸互动教学',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product/1.png',
          desc: '学生在虚拟环境中通过高度参与互动、演练从而提高学习效率'
        },
        {
          title: '丰富的教学资源',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product/2.png',
          desc:
            '12000+教育资源，包含可交互VR课件、3D模型、全景图片、视频等'
        },
        {
          title: '强大的课堂管理',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product/3.png',
          desc: '跨平台使用，支持老师备课，课堂管理，设备监督等功能'
        }
        // {
        //   title:'',
        //   img:'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/product/4.png'
        // }
      ],
      listK12: [
        {
          title: '北京朝阳实验小学',
          desc:
            'VR未来课堂将虚拟现实技术与实际教学知识点紧密结合，打造与实际教育教学高度集合的高仿真、沉浸式、可交互的解决方案，推展学习空间，提高学习兴趣，增强学习主动探究能力、创造力',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/eg/5.jpg'
        },
        {
          title: '北京清华大学附属中学',
          desc:
            '智慧宫是一款基于 5G 6DOF VR 模拟物、化、生实验场景，提供规范的实验内容、自由化交互， 结合学科实验设计的一套符合课程标准、考试要求的实验课程，该产品既能教学、也能考核。不仅解决了传统实验中遇到的高危操作、实验准备周期长、实验室不足等一系列问题，而且还能够进行批量考核',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/eg/6.jpg'
        },
        {
          title: '青岛市崂山区沙子口小学',
          desc:
            '覆盖中小学语文、英语、科学、物理、化学、生物、地理、历史、安全、国学、心理等内容，跨平台使用，支持老师备课、课程管理、设备监督，推动学校教育信息化建设，促进教育资源共享，推动教育资源均衡',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/eg/1.jpg'
        }
      ]
    };
  },
  methods: {
    go() {
      window.location.href = 'http://www.growlib.com/';
    }
  }
};
</script>
<style lang="less" scoped>
.main {
  .banner {
    width: 100%;
    height: 500px;
    display: block;
  }
  .oldWorld {
    position: relative;
    margin-top: -100px;
    padding-bottom: 76px;
    top: 0;
    right: 0;
    z-index: 1;
    font-size: 24px;
    line-height: 1;
    color: #333;
    text-align: right;
    padding-right: 100px;
    cursor: pointer;
  }
  .introduce {
    width: 100%;
    height: 487px;
    background: #fff;
    padding-top: 1px;
    > div {
      width: 1200px;
      margin: 0 auto;
      background: #9aa4b9;
      height: 422px;
      margin-top: 120px;
      position: relative;
      padding-left: 546px;
      box-sizing: border-box;
      padding-top: 1px;
      .img {
        position: absolute;
        top: -54px;
        left: 51px;
        width: 460px;
        height: 550px;
        padding: 12px;
        box-sizing: border-box;
        background: #fff;
        box-shadow: 1px 2px 5px 2px rgba(0, 0, 0, 0.08);
        border: 1px solid #efefef;
      }
      .title {
        font-size: 36px;
        font-weight: bold;
        color: #ffffff;
        line-height: 1;
        margin-top: 84px;
      }
      .desc {
        width: 628px;
        font-size: 24px;
        font-weight: 400;
        color: #ffffff;
        line-height: 36px;
        margin-top: 20px;
        span {
          display: block;
        }
      }
    }
  }
  .details {
    margin: 0 auto;
    padding-top: 0px;
    width: 1200px;
    margin: 0 auto;
    .title {
      text-align: center;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.6);
      line-height: 63px;
    }
    .content {
      // display: flex;
      margin-top: 50px;
      img:nth-child(1) {
        width: 740px;
        height: 290px;
        margin-right: 40px;
      }
      img:nth-child(2) {
        width: 420px;
        height: 290px;
      }
    }
    .desc {
      font-size: 24px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #80889a;
      line-height: 40px;
      margin-top: 50px;
    }
  }
  .plan {
    width: 1200px;
    height: auto;
    margin: 0 auto;
    padding-top: 1px;
    .title {
      font-size: 42px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.6);
      line-height: 63px;
      text-align: center;
      margin-top: 177px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      padding-bottom: 36px;
      margin-top: 30px;
      .list {
        // width: 241px;
        img {
          width: 241px;
          height: 241px;
          border-radius: 6px;
          margin: 0 auto;
        }
        .desc {
          text-align: center;
          font-size: 28px;
          font-weight: bold;
          color: #9fa1b4;
          line-height: 40px;
          margin-top: 20px;
        }
      }
    }
  }
  .offline {
    width: 1200px;
    margin: 0 auto;
    padding: 44px 0 137px 0;
    .title {
      font-size: 42px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.6);
      line-height: 1;
      text-align: center;
    }
    .content {
      width: 100%;
      height: 505px;
      position: relative;
      padding-right: 695px;
      box-sizing: border-box;
      margin-top: 50px;
      img {
        width: 449px;
        height: 225px;
      }
      img:nth-child(2) {
        margin-top: 55px;
      }
      img:nth-child(3) {
        position: absolute;
        top: 0;
        right: 0;
        width: 695px;
        height: 100%;
      }
    }
  }
  .case {
    width: 100%;
    background: #fff;
    > div {
      width: 1200px;
      height: 691px;
      margin: 0 auto;
      padding-top: 1px;
      .title {
        font-size: 42px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.6);
        line-height: 1;
        text-align: center;
        margin-top: 48px;
      }
      .content {
        width: 100%;
        display: flex;
        height: 391px;
        margin-top: 49px;
        .hasImg {
          width: 33.3%;
          height: 100%;
          box-sizing: border-box;
          border-right: 1px solid #dadada;
          padding: 0 30px;
          &:nth-child(3) {
            border: none;
          }
          img {
            width: 100%;
            height: 200px;
          }
          .headline {
            margin-top: 40px;
            line-height: 1;
            font-size: 28px;
            font-weight: bold;
            color: #9fa1b4;
            display: block;
            &:nth-of-type(2) {
              margin-top: 10px;
            }
          }
          .desc {
            display: block;
            font-size: 18px;
            font-weight: 400;
            color: #9fa1b4;
            line-height: 24px;
            margin-top: 20px;
          }
        }
        .noImg {
          width: 33.3%;
          height: 100%;
          > div {
            width: 100%;
            padding: 15px;
            box-sizing: border-box;
            &:last-child {
              border-top: 1px solid #dadada;
            }
            .headline {
              font-size: 28px;
              font-weight: bold;
              color: #9fa1b4;
              line-height: 40px;
              min-height: 92px;
            }
            .desc {
              font-size: 18px;
              font-weight: 400;
              color: #9fa1b4;
              line-height: 24px;
              margin-top: 20px;
            }
          }
        }
      }
      .more {
        margin-top: 64px;
        display: flex;
        justify-content: center;
        span {
          font-size: 24px;
          color: #9fa1b4;
          line-height: 1;
        }
        img {
          width: 22px;
          height: 18px;
        }
      }
    }
  }
}
@media (max-width: 1000px) {
  .main{
    .banner {
      width: 100%;
      height: 348px;
      display: block;
    }
    .details{
      padding: 0 48px;
      width: 100%;
      .title{
        font-size: 44px;
        margin-top: 80px;
      }
      .content{
        margin-top: 80px;
        img:nth-child(1) {
          width: 410px;
          height: 160px;
          margin-right: 12px;
        }
        img:nth-child(2) {
          width: 230px;
          height: 160px;
        }
      }
      .desc{
        margin-top: 40px;
        font-size: 28px;
        line-height: 40px;
        padding-bottom: 80px;
      }
    }
  }
}
</style>
